import type { Msg, Session } from '@halo/chat-sdk';
import { useEffect, useState } from 'react';
import { useStaticAppStore } from './useStaticAppStore';

export interface UseMsgProps {
  sessionId: Session['chat_id'];
  cliMsgId: Msg['cli_msg_id'];
}

export function useMsg({ sessionId, cliMsgId }: UseMsgProps) {
  const { client } = useStaticAppStore();
  const [msg, setMsg] = useState<Msg | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);
  const [isDeleted, setIsDeleted] = useState<boolean>(false);

  useEffect(() => {
    if (client && cliMsgId && sessionId) {
      setLoading(true);

      const promise = client.Api.messages.getMsgByCliMsgId(
        sessionId,
        cliMsgId,
        (msg, isDeleted) => {
          setMsg(msg);
          setIsDeleted(isDeleted);
        }
      );

      promise.finally(() => {
        setLoading(false);
      });

      return promise.removeListener;
    }
  }, [client, sessionId, cliMsgId]);

  return {
    msg,
    loading,
    isDeleted,
  };
}
